import { useEffect, useState } from "react";

// Must match the mobile-handoff library's internal 768px (Tailwind `md`)
// breakpoint. The library shows the QR/desktop-handoff UI at >= 768px and the
// direct-camera UI below it; keeping this identical ensures the app's polling
// gate flips at the exact width the QR appears/disappears.
const DESKTOP_QUERY = "(min-width: 768px)";

export function useIsMobile(): boolean {
  const [isMobile, setIsMobile] = useState<boolean>(() =>
    typeof window === "undefined"
      ? false
      : !window.matchMedia(DESKTOP_QUERY).matches
  );

  useEffect(() => {
    const mql = window.matchMedia(DESKTOP_QUERY);
    const onChange = (event: MediaQueryListEvent) => setIsMobile(!event.matches);
    setIsMobile(!mql.matches);
    mql.addEventListener("change", onChange);
    return () => mql.removeEventListener("change", onChange);
  }, []);

  return isMobile;
}
